/* @refresh reload */
import '@/sentry'
import { render } from 'solid-js/web'
import routerFunction from "./router"
import './sass/index.sass'

const root = document.getElementById('root') as HTMLElement

render(routerFunction, root)
